import FailedLoginAttempts from '@/views/failed-login-attempts/failed-login-attempts.vue'
import ShowFailedLoginAttempt from '@/views/failed-login-attempts/show-failed-login-attempt.vue'
import { FailedLoginAttemptsRouteNames } from '@/router/routes-names'

export const failedLoginAttemptsRoutes = [
    {
        path: '/failed-login-attempts',
        name: FailedLoginAttemptsRouteNames.LIST,
        component: FailedLoginAttempts,
        props: true
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
        path: '/failed-login-attempts/show/:id',
        name: FailedLoginAttemptsRouteNames.SHOW,
        component: ShowFailedLoginAttempt
    }
]
